module.exports = __webpack_public_path__ + "img/ups.515a08e3.png";